import { Preferences } from '@capacitor/preferences'
import { SavePreferences } from './types/preference.interface'

const savePreference = async ({ key, value }: SavePreferences) => {
	try {
		if (value === null) {
			// Remove the preference when value is null
			await Preferences.remove({ key })
		} else {
			// Store the value (already stringified by usePreference hook)
			await Preferences.set({ key, value })
		}
	} catch (error) {
		console.error('Error saving preferences:', error)
	}
}
export default savePreference
